import React from 'react'
import PropTypes from 'prop-types'
import {TabPanelBox} from 'hec/components/content-tabs'

export const BuilderTabPanelBox = (props) => {
    return <TabPanelBox {...props} />
}

BuilderTabPanelBox.propTypes = {
    attributes: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object),
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const TabPanelBoxDefinition = {
    component: BuilderTabPanelBox,
    name: 'Tab Panel',
    noWrap: true,
    canHaveChildren: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    inputs: [
        {
            name: 'content',
            type: 'uiBlocks',
            defaultValue: []
        }
    ]
}
